import type { LetterCharacter } from '../types';

// Scrabble-style letter point values
export const LETTER_VALUES: Record<LetterCharacter, number> = {
  A: 1, E: 1, I: 1, O: 1, U: 1, L: 1, N: 1, S: 1, T: 1, R: 1, // 1 point
  D: 2, G: 2, // 2 points
  B: 3, C: 3, M: 3, P: 3, // 3 points
  F: 4, H: 4, V: 4, W: 4, Y: 4, // 4 points
  K: 5, // 5 points
  J: 8, X: 8, // 8 points
  Q: 10, Z: 10, // 10 points
};
